// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"34cbfb6a","142":"51499b32","168":"3d828598","253":"a84880f8","368":"73ee2c04","443":"595eadab","497":"4c7d2b24","532":"b32a2715","549":"85fabf6f","568":"f8aad46b","578":"c485a012","637":"ac652d61","764":"11840834","775":"526aeb50"}[chunkId] + ".chunk.js";
};